<script>
  import {getContext} from 'svelte';
  import Modal from './Modal.svelte';
	// import Following from './Following.svelte';
	let showModal = false;

  let firebase = getContext('firebase').getFirebase();
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";
  
  import { listId } from './stores.js';
  let user;

  var provider = new firebase.auth.GoogleAuthProvider();
  function signupGoogle(){
		// alert("@signupGoogle");
    firebase.auth().signInWithPopup(provider).then(function(result) {
		// console.log("@signupGoogle2")
		// alert("@signupGoogle2");
    // This gives you a Google Access Token. You can use it to access the Google API.
    // var token = result.credential.accessToken;
    // The signed-in user info.
		user = result.user;
		// console.log("got user="+JSON.stringify(user));
		// // userid.set(user.uid);
		// // username.set(user.displayName);
		// console.log("user.displayName: "+user.displayName);
    
    
    // TODO updateUserfile(user);
    
    
    // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
			// ...
			console.log(errorMessage+"      "+error.code);
    });
  }

  const logout = function(auth){
    showModal = false; 
    auth.signOut()
  }

  // console.log("@Header.svelte")
</script>


<div class="re-header">
  <div class="re-logo">
    <a href="/"><img noroute src="/images/manifest/icon-72x72.png" alt="re-logo" />
  </a></div>
  <div class="re-title">Reading.email</div>
  <div class="re-login">
    <User let:user let:auth>
      <!-- {JSON.stringify(user)} -->
      <!-- <button on:click={() => auth.signOut()}>Sign Out</button> -->
      {#if user.displayName}
        <span on:click="{() => showModal = true}" class="displayName displaynone">{user.displayName}</span>
        <img on:click="{() => showModal = true}" class="re-photo" width="33px" height="33px" alt="photo of {user.displayName}" src="{user.photoURL}">
      {:else}
        <span on:click="{() => showModal = true}" class="displayName displaynone">{user.uid}</span>
      {/if}
      <div slot="signed-out" class="signed-out">
        <button on:click={() => signupGoogle()}>
          Google Sign In
        </button>
      </div>

      {#if showModal}
        <Modal on:close="{() => showModal = false}">
          <h2 slot="header">Private Membership Info </h2>
          <div slot="logout">
            <button on:click={() => logout(auth)}>Sign Out</button>
          </div>
        </Modal>
      {/if}
    </User>
  </div><!-- /re-login --> 
</div>

<style>
  a img {border:0;}
  .re-header {display: grid; grid-template-columns: 1fr 1fr 1fr; 
    color: white; background-color: cornflowerblue; padding: 2px 1rem;  height: 60px;}
  .re-login {text-align: right; margin: auto 0;}
  .re-logo img {height: 50px;}
  .re-logo {margin: auto 0; }
  .re-title {font-size: 2rem; text-align: center; margin: auto 0;}
  .re-photo {border-radius: 5px;}
  .displayName {font-size: 1rem;}
  @media (max-width: 800px) {
    /* .issue {display: none;} */
    .displaynone {display:none}
  }
</style>